module.exports = __webpack_public_path__ + "static/media/utensil-fork.f15f640b.svg";